import React from 'react'
import { Link, Route, Switch } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import ProtectedRoute from './auth/protected-route'
import { Page } from './components/Page'
import { Dashboard } from './dashboard'
import { Home } from './home'
import { Profile } from './profile'
import { identify } from './utils/analytics/segment'

const Login = () => <div>Login</div>

const NotFound = () => (
  <Page title="Page Not Found">
    <Link to="/dashboard">
      <a>Go To Dashboard</a>
    </Link>
  </Page>
)

// import logo from './logo.svg';
// import './App.css';

function App() {
  const { isLoading, user } = useAuth0()

  if (user) {
    identify(user.sub, { email: user.email })
  }

  console.log(user)

  if (isLoading) {
    return <Page>Loading...</Page>
  }

  return (
    <div id="app">
      <Switch>
        <Route path="/" exact={true} component={Home} />
        <Route path="/login" component={Login} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <ProtectedRoute path="/profile" component={Profile} />
        <Route component={NotFound} />
      </Switch>
    </div>
  )
}

export default App
